import type { FormEvent } from "react";

/** Commit native input events as well as change events. Some supported browser/date
 * editors emit input without React's synthetic change callback. Reading the DOM
 * immediately after editing does not prove that a controlled value was committed. */
export function EnrollmentDateTimeInput({ value, onValue }: { value: string; onValue: (value: string) => void }) {
  const commit = (event: FormEvent<HTMLInputElement>) => onValue(event.currentTarget.value);
  return <input type="datetime-local" step={1} value={value} onInput={commit} onChange={commit} />;
}

export function enrollmentUtcPreview(value: string): string {
  const date = new Date(value);
  return Number.isFinite(date.getTime()) ? date.toISOString() : "—";
}
